export const PERMISSIONS = {
  // ---- Business ----
  BUSINESS_GET_RESELLER:   "business.getreseller",
  BUSINESS_GET_TYPES:      "business.gettypes",
  BUSINESS_GET_SINGLE:     "business.getsingle",
  BUSINESS_GET_FEECAPS:    "business.getfeecaps",
  BUSINESS_ADD:            "business.add",
  BUSINESS_UPDATE:         "business.update",
  BUSINESS_GET_PROPS:      "business.getprops",
  BUSINESS_UPDATE_PROPS:   "business.updateprops",
  BUSINESS_GET_LOG:        "business.getlog",
  BUSINESS_UPLOAD:         "business.upload",

  // ---- Terminal ----
  TERMINAL_GET_ALL:        "terminal.getall",
  TERMINAL_GET_SINGLE:     "terminal.getsingle",
  TERMINAL_UPSERT:         "terminal.upsert",
  TERMINAL_ENROL_CODE:     "terminal.enrolcode",
  TERMINAL_GET_LOG:        "terminal.getlog",

  // ---- Fee ----
  FEE_GET_TYPES:           "fee.gettypes",

  // ---- Transaction ----
  TRANSACTION_GET_SUMMARY_RESELLER: "transaction.getsummaryreseller",
  TRANSACTION_GET_RESELLER:         "transaction.getreseller",

  // ---- Role ----
  ROLE_GET_RESELLER:       "role.getreseller",
  ROLE_GET_SINGLE:         "role.getsingle",
  ROLE_ADD:                "role.add",
  ROLE_UPDATE:             "role.update",
  ROLE_DELETE:             "role.delete",

  // ---- Invite ----
  INVITE_GET_RESELLER:     "invite.getreseller",
  INVITE_CREATE:           "invite.create",

  // ---- User (NEW) ----
  USER_ADD:                "user.add",
  USER_GET_RESELLER:       "user.getreseller",
  USER_GET_SINGLE:         "user.getsingle",
  USER_LOCK:               "user.lock",
  USER_UPDATE:             "user.update",
};

export const ALL_PERMISSIONS = Object.values(PERMISSIONS);